<!-- This component is currently used for testing purpose only -->
@if (currentUser) {
<div id="user2s">
  <form [formGroup]="userForm">
    <mat-form-field>
      <input matInput name="emailAddress" readonly placeholder="Email Address:" formControlName="emailAddress" />
    </mat-form-field>
    <mat-form-field>
      <input matInput name="firstName" placeholder="First Name:" formControlName="firstName" />
    </mat-form-field>
    <mat-form-field>
      <input matInput name="lastName" placeholder="Last Name:" formControlName="lastName" />
    </mat-form-field>
    <br />
    <app-changepassword></app-changepassword>
    <div class="save-button-div">
      <button mat-raised-button color="primary" (click)="save()" [disabled]="!userForm.valid || !userForm.dirty">Save</button>
    </div>
  </form>
</div>
}
